import { HttpError } from "@microbeta/common-frontend";
import { sendToastMessage } from "@microbeta/ui";
import { QueryClient } from "@tanstack/react-query";
import i18n from "@/features/i18n/i18n";

const getErrorMessage = (error: unknown): string => {
  if (error instanceof HttpError) {
    switch (error.status) {
      case 401:
        return i18n.t("errors.sessionExpired");
      case 403:
        return i18n.t("errors.forbidden");
      case 404:
        return i18n.t("errors.notFound");
      case 500:
        return i18n.t("errors.serverError");
      default:
        return i18n.t("errors.genericError");
    }
  }

  if (error instanceof Error) {
    // Don't expose raw error messages to users
    return i18n.t("errors.genericError");
  }

  return i18n.t("errors.unexpectedError");
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60,
      staleTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except 408 (timeout)
        if (
          error instanceof HttpError &&
          error.status >= 400 &&
          error.status < 500 &&
          error.status !== 408
        ) {
          return false;
        }
        return failureCount < 3;
      },
    },
    mutations: {
      onError: (error) => {
        console.error("Mutation error:", error);
        // Don't show toast for 401 errors as they're handled globally by AuthContext
        if (!(error instanceof HttpError && error.status === 401)) {
          sendToastMessage(getErrorMessage(error), "", "error");
        }
      },
    },
  },
});
